import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import ProductItem from '../product/product-item';
import ProductItemCol from '../product/product-col-item';
import { kv } from "../../mixin/kv";
import { rebate } from "../../mixin/rebate";
import Pager from '../pager/index';
import Dialog from '../v2-dialog/index';
import { purchaseQuantityProcessing } from '@/utils';
export default {
  mixins: [kv, rebate],
  components: {
    ProductItem: ProductItem,
    ProductItemCol: ProductItemCol,
    Pager: Pager,
    Dialog: Dialog
  },
  data: function data() {
    return {
      list: [],
      k_code: "5",
      isColList: false,
      //是否列表模式
      queryParam: {
        productName: '',
        page: 1
      },
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  props: {
    show: {
      type: Boolean
    }
  },
  watch: {
    show: function show(newV) {
      if (newV) {
        this.queryParam.page = 1;
        this.queryParam.productName = '';
        this.getList();
        this.kv_visit(5);
      }
    }
  },
  inject: ["reload"],
  methods: {
    close: function close() {
      //如果页面在购物车页面，需要刷新一下页面
      if (this.$route.name == 'v2-shopcard') {
        this.reload();
      }
      this.$emit('close');
    },
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, query, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/pjyy-deepexi-product-center/api/v4/product/PcProductCommon/rebates";
              query = {
                page: _this.queryParam.page,
                pageSize: 20,
                param: _this.queryParam.productName
              };
              _context.next = 4;
              return _this.$getHttpClient().post(url, query);
            case 4:
              result = _context.sent;
              if (result.data.code == '200') {
                _this.list = purchaseQuantityProcessing(result.data.data.list);
                _this.pageInfo.total = result.data.data.total;
                _this.pageInfo.pageNum = result.data.data.pageNum;
                _this.pageInfo.pageSize = result.data.data.pageSize;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    search: function search() {
      this.queryParam.page = 1;
      this.getList();
    },
    getDataByPage: function getDataByPage(pageNum, productName, sortType, activity) {
      this.toTop();
      this.queryParam.productName = productName;
      this.queryParam.page = pageNum;
      this.getList();
    },
    //大图列表转换
    swich: function swich(flag) {
      this.isColList = flag;
    },
    toTop: function toTop() {
      var timer = setInterval(function () {
        var osTop = document.getElementsByName('dialog-content')[0].scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.getElementsByName('dialog-content')[0].scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};